import { makeStyles, Text } from '@rneui/themed'
import {
  shiftDurationString,
  timeStringFrom24HourTimeString,
} from '@nextforce/api'
import { Shift } from '@nextforce/api'
import React from 'react'

interface Props {
  shift: Shift
  showDuration?: boolean
}

export function ShiftTimeRangeView({ shift, showDuration }: Props) {
  const styles = useStyles()

  return (
    <Text style={styles.container}>
      <Text style={styles.startTime}>
        {timeStringFrom24HourTimeString(shift.startTime)}
      </Text>
      {' - '}
      <Text style={styles.endTime}>
        {timeStringFrom24HourTimeString(shift.endTime)}
      </Text>
      {showDuration && (
        <Text style={styles.duration}>{`\n${shiftDurationString(shift)}`}</Text>
      )}
    </Text>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    fontSize: 13,
  },
  startTime: {
    color: theme.colors?.black,
  },
  endTime: {
    color: theme.colors?.grey2,
  },
  duration: {
    color: theme.colors?.grey2,
  },
}))
